import { withApollo } from 'react-apollo';
import EmployeeGridAntD from 'src/recognitionSettings/employee-manager/EmployeeGridAntD.jsx';
import { useSelector } from 'react-redux';
import { Spinner } from 'src/_shared/index.js';
import { brightenHexColor } from 'src/_shared/services/utils';

const EmployeePage = (props) => {
    const currentUser = useSelector((state) => state.user.currentUser);
    const menuColor = typeof currentUser?.company?.theme === 'string' ? JSON.parse(currentUser?.company?.theme)?.menuColor : "#1890ff";
    const menuColorHighlight = brightenHexColor(menuColor, 10);
    const customTheme = {
        bgHeader: '#fafafa',
        bgHeaderHovered: menuColorHighlight,
        bgHeaderHasFocus: menuColorHighlight,
        headerFontStyle: '600 14px',
        textHeader: '#000000D9',
        verticalBorderColor: '#0000FF',
        cellHorizontalPadding: '16',
        callVerticalPadding: '16',
        fontFamily: 'Nunito Sans',
        baseFontStyle: '14px',
        headerFontStyle: 'bold 14px',
        rowHeight: '54px'

    }
  if (!currentUser?.company) return <Spinner />;
  return (
    <>
    <div className="employee-page-container main">
        <div className="page-title">
  	<h2 className="page-heading-manage-reward">Recognition Users</h2>
  </div>
      <div className="employee-grid-wrapper">
        <EmployeeGridAntD client={props.client} menuColor={menuColor} theme={customTheme} currentUser={currentUser} companyId={currentUser?.companyId} />
      </div>
    </div>
    </>
  );
};

export default withApollo(EmployeePage);
